/**
 * คำอธิบายของทางเดียวที่เหลือ เมื่อรายการพ้น `DRAFT` ไปแล้ว
 *
 * ข้อความก้อนนี้ถูกใช้สองที่และต้องเป็นก้อนเดียวกัน: ตอนที่หน้าจอรู้เองว่ารายการ
 * ไม่ใช่ `DRAFT` (จึงไม่เปิดฟอร์มให้) และตอนที่เซิร์ฟเวอร์ตอบ `422` พร้อม
 * `details.rule = PRODUCT_EDITABLE_ONLY_IN_DRAFT` ถ้าสองที่นี้พูดไม่เหมือนกัน
 * ผู้ใช้จะเจอคำอธิบายคนละแบบสำหรับสถานการณ์เดียวกัน
 *
 * **สิ่งที่เปลี่ยนไปจากเวอร์ชันก่อน**: ก้อนนี้เคยบอกว่าหน้าจอคำขอเปลี่ยนแปลง
 * "ยังไม่ถูกสร้าง" และห้ามมีปุ่มด้วยเหตุผลนั้น — ตอนนี้หน้าจอมีจริงแล้ว
 * (`ProductChangeRequestView`) ข้อความเดิมจึงกลายเป็นคำที่ไม่จริง และหน้าจอที่
 * บอกว่าทางตันทั้งที่มีทางอยู่ ก็สอนให้ผู้ใช้เลิกหาเหมือนกับปุ่มที่กดแล้วไม่ไปไหน
 *
 * ลิงก์จะโผล่ก็ต่อเมื่อผู้เรียกส่ง `productId` มาให้เท่านั้น — ที่ไหนไม่รู้ว่า
 * กำลังพูดถึงรายการไหน ที่นั่นไม่มีปลายทางให้ไปจริง ๆ และต้องไม่แกล้งมี
 *
 * ลิงก์นี้ไม่มี class ของ design system เพราะยังไม่มีคลาสของลิงก์ในเนื้อความใน
 * `desktop.css` (มีแต่ `cap-table__link` ซึ่งเป็น mono + nowrap สำหรับในตาราง)
 * และไฟล์ stylesheet อยู่นอก write scope ของ Work Order นี้ — ใส่ชื่อคลาสที่ยัง
 * ไม่มีกฎรองรับไว้ จะได้ชื่อที่ดูเหมือนมีสไตล์แต่ไม่มีจริง
 */

import { Link, useLocation } from 'react-router-dom';

import { changeRequestsSearch } from './productView';

export interface ProductChangeRequestNoteProps {
  /** รายการที่กำลังพูดถึง — ไม่ส่งมา = ไม่มีลิงก์ ไม่ใช่ลิงก์ที่เดารหัสเอง */
  readonly productId?: string;
}

export function ProductChangeRequestNote({ productId }: ProductChangeRequestNoteProps = {}) {
  const { pathname } = useLocation();

  return (
    <p className="cap-notice__note" data-testid="product-change-request-note">
      รายการนี้ผ่านขั้น “ร่าง (DRAFT)” ไปแล้ว การแก้ไขโดยตรงจึงทำไม่ได้อีก (D-011) —
      ทางเดียวที่แก้รายการซึ่งอนุมัติแล้วได้คือ{' '}
      <strong>คำขอเปลี่ยนแปลงข้อมูลสินค้า (product change request)</strong>{' '}
      ซึ่งต้องผ่านการอนุมัติเหมือนกัน และครอบคลุมการปิดใช้งานด้วย (D-042)
      {productId === undefined ? (
        <> — เปิดหน้าคำขอเปลี่ยนแปลงได้จากหน้ารายละเอียดของรายการนั้น</>
      ) : (
        <>
          {' '}
          <Link
            data-testid="product-change-request-link"
            to={{ pathname, search: changeRequestsSearch(productId) }}
          >
            เปิดหน้าคำขอเปลี่ยนแปลงของรายการนี้
          </Link>
        </>
      )}
    </p>
  );
}
